// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c7e7a44b","453":"28b7f8b6","455":"167e3b81","977":"3ba5cbee"}[chunkId] + ".chunk.js";
};